module.exports = __webpack_public_path__ + "img/m-banner-rvzldswd-tr-TR.9207fdb7.jpg";